/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponsePagedResultReferentialVariable } from '../models/api-response-paged-result-referential-variable';
import { ApiResponseReferentialVariable } from '../models/api-response-referential-variable';
import { archiveCompanyVariable } from '../fn/company-variable-api/archive-company-variable';
import { ArchiveCompanyVariable$Params } from '../fn/company-variable-api/archive-company-variable';
import { createCompanyVariable } from '../fn/company-variable-api/create-company-variable';
import { CreateCompanyVariable$Params } from '../fn/company-variable-api/create-company-variable';
import { getCompanyVariable } from '../fn/company-variable-api/get-company-variable';
import { GetCompanyVariable$Params } from '../fn/company-variable-api/get-company-variable';
import { searchCompanyVariables } from '../fn/company-variable-api/search-company-variables';
import { SearchCompanyVariables$Params } from '../fn/company-variable-api/search-company-variables';
import { updateCompanyVariable } from '../fn/company-variable-api/update-company-variable';
import { UpdateCompanyVariable$Params } from '../fn/company-variable-api/update-company-variable';

@Injectable({ providedIn: 'root' })
export class CompanyVariableApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `createCompanyVariable()` */
  static readonly CreateCompanyVariablePath = '/v1/api/ui/referential/variable';

  /**
   * Requires REFERENTIAL_VAR_MANAGE. Reads global plus JWT company variables; modifies only company-owned definitions. Payload ownership fields are ignored.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createCompanyVariable()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createCompanyVariable$Response(params: CreateCompanyVariable$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseReferentialVariable>> {
    return createCompanyVariable(this.http, this.rootUrl, params, context);
  }

  /**
   * Requires REFERENTIAL_VAR_MANAGE. Reads global plus JWT company variables; modifies only company-owned definitions. Payload ownership fields are ignored.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createCompanyVariable$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createCompanyVariable(params: CreateCompanyVariable$Params, context?: HttpContext): Observable<ApiResponseReferentialVariable> {
    return this.createCompanyVariable$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseReferentialVariable>): ApiResponseReferentialVariable => r.body)
    );
  }

  /** Path part for operation `searchCompanyVariables()` */
  static readonly SearchCompanyVariablesPath = '/v1/api/ui/referential/variable/search';

  /**
   * Requires REFERENTIAL_VAR_MANAGE. Reads global plus JWT company variables; modifies only company-owned definitions. Payload ownership fields are ignored.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchCompanyVariables()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchCompanyVariables$Response(params: SearchCompanyVariables$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultReferentialVariable>> {
    return searchCompanyVariables(this.http, this.rootUrl, params, context);
  }

  /**
   * Requires REFERENTIAL_VAR_MANAGE. Reads global plus JWT company variables; modifies only company-owned definitions. Payload ownership fields are ignored.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchCompanyVariables$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchCompanyVariables(params: SearchCompanyVariables$Params, context?: HttpContext): Observable<ApiResponsePagedResultReferentialVariable> {
    return this.searchCompanyVariables$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponsePagedResultReferentialVariable>): ApiResponsePagedResultReferentialVariable => r.body)
    );
  }

  /** Path part for operation `getCompanyVariable()` */
  static readonly GetCompanyVariablePath = '/v1/api/ui/referential/variable/{ref}';

  /**
   * Requires REFERENTIAL_VAR_MANAGE. Reads global plus JWT company variables; modifies only company-owned definitions. Payload ownership fields are ignored.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCompanyVariable()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompanyVariable$Response(params: GetCompanyVariable$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseReferentialVariable>> {
    return getCompanyVariable(this.http, this.rootUrl, params, context);
  }

  /**
   * Requires REFERENTIAL_VAR_MANAGE. Reads global plus JWT company variables; modifies only company-owned definitions. Payload ownership fields are ignored.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCompanyVariable$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompanyVariable(params: GetCompanyVariable$Params, context?: HttpContext): Observable<ApiResponseReferentialVariable> {
    return this.getCompanyVariable$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseReferentialVariable>): ApiResponseReferentialVariable => r.body)
    );
  }

  /** Path part for operation `updateCompanyVariable()` */
  static readonly UpdateCompanyVariablePath = '/v1/api/ui/referential/variable/{ref}';

  /**
   * Requires REFERENTIAL_VAR_MANAGE. Reads global plus JWT company variables; modifies only company-owned definitions. Payload ownership fields are ignored.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateCompanyVariable()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateCompanyVariable$Response(params: UpdateCompanyVariable$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseReferentialVariable>> {
    return updateCompanyVariable(this.http, this.rootUrl, params, context);
  }

  /**
   * Requires REFERENTIAL_VAR_MANAGE. Reads global plus JWT company variables; modifies only company-owned definitions. Payload ownership fields are ignored.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateCompanyVariable$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateCompanyVariable(params: UpdateCompanyVariable$Params, context?: HttpContext): Observable<ApiResponseReferentialVariable> {
    return this.updateCompanyVariable$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseReferentialVariable>): ApiResponseReferentialVariable => r.body)
    );
  }

  /** Path part for operation `archiveCompanyVariable()` */
  static readonly ArchiveCompanyVariablePath = '/v1/api/ui/referential/variable/archive/{ref}';

  /**
   * Requires REFERENTIAL_VAR_MANAGE. Reads global plus JWT company variables; modifies only company-owned definitions. Payload ownership fields are ignored.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `archiveCompanyVariable()` instead.
   *
   * This method doesn't expect any request body.
   */
  archiveCompanyVariable$Response(params: ArchiveCompanyVariable$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return archiveCompanyVariable(this.http, this.rootUrl, params, context);
  }

  /**
   * Requires REFERENTIAL_VAR_MANAGE. Reads global plus JWT company variables; modifies only company-owned definitions. Payload ownership fields are ignored.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `archiveCompanyVariable$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  archiveCompanyVariable(params: ArchiveCompanyVariable$Params, context?: HttpContext): Observable<void> {
    return this.archiveCompanyVariable$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
